import { status } from './status';
import { alphas } from './system/alphas';

const darken = (base: string, scale: number) =>
  `color-mix(in hsl, ${base} ${100 - scale}%, black)`;

export const borders = {
  border: alphas['darken-20'],
  'border.hover': alphas['darken-30'],
  'border.divider': alphas['darken-10'],
  'border.status.active.light': darken(status['status.active.light'], 5),
};
